/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../index.js';
import '../../../tslib.es6-e01eabb2.js';
import '../../env/index.js';
import '../../../index-f24a9ec1.js';
import '../../../index-892d8eee.js';
import '../register/index.js';
import '../../../bridges/dd/index.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';

/**
 * Adapter加载机制
 * @example
 *
 * import * as CnUniApi from '@alife/cn-uni-api';
 *
 * CnUniApi.loadAdapter(require('@alife/adapter-xiniao-to-cnuniapi')
 *
 * @param adapter
 * @returns
 */
var loadAdapter = function (adapter, userAgentId) {
    if (userAgentId === void 0) { userAgentId = 'web'; }
    // @ts-ignore this改写
    var cnUniApi = this;
    function addClient(appClient, clientName) {
        Object.keys(appClient).forEach(function (apiFunctionName) {
            var _a;
            var clientFn = appClient[apiFunctionName];
            var orignalFn = cnUniApi[apiFunctionName];
            cnUniApi[apiFunctionName] = extend((_a = {}, _a[clientName] = clientFn, _a), orignalFn);
        });
    }
    addClient(adapter, userAgentId);
    return cnUniApi;
};

export { loadAdapter };
